import * as React from 'react'
import TextInput from '../TextInput'

const NewPasswordTextInput = (props) => (
  <React.Fragment>
    <TextInput type="password" {...props} />
  </React.Fragment>
)

export default NewPasswordTextInput
